import { render, staticRenderFns } from "./BlockBlogListItem.vue?vue&type=template&id=2cf7b85d&scoped=true&"
import script from "./BlockBlogListItem.vue?vue&type=script&lang=js&"
export * from "./BlockBlogListItem.vue?vue&type=script&lang=js&"
import style0 from "./BlockBlogListItem.vue?vue&type=style&index=0&id=2cf7b85d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf7b85d",
  null
  
)

export default component.exports